<div class="image-editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['display-property']['width']" [height]="class['display-property']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" >
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_van_ban' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="container-font">
          <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [textContentClass]="class['display-property__item']" [textWrapperClass]="class['display-property__item']"
            (changeTextAlignConfig)="changeWidthHeight({width: class['display-property__item']['width']})">
          </app-text-format-config>
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLetterSpacing]="class['display-property__item']" (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLineHeight]="class['display-property__item']" (updateClass)="updateClass()">
          </app-line-height-config>
        </div>
      </li>
      <!-- Khoảng đệm -->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['display-property']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
        </app-padding-config>
      </li>
      <!-- Upload ảnh -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="upload-image" *ngIf="!isViewAll">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config  [elementChoosing]="objectChoosing" [device]="device" >
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </div>
  <!-- Mở rộng -->
  <div class="view-more" *ngIf="isViewAll">

  </div>
</div>
